<template>
  <div id="slide-show-form-editor">
    <div class="fadeInUp fade animated">
      <CRow style="padding:0 10px;">
        <template>
          <CCol xs="12" md="12" lg="12" xl="12">
            <div class="input-wrapper form-input-wrapper">
              <div class="form-group">
                <label>Trong khung</label>
                <div>
                  <CInputCheckbox custom :checked="item.parent" class="ml-2"
                                  @update:checked="changeParent($event)"
                                  addInputClasses="override-custom"></CInputCheckbox>
                </div>
              </div>
            </div>
          </CCol>
        </template>
        <template
          v-if="type == typeLayer.TEXT || type == typeLayer.RSS || type == typeLayer.AREA_TEXT || (item.extractData.typeLayer == typeLayer.PLAY_LIST
          && (item.extractData.type == typePlayList.TEXT_RUN || item.extractData.type == typePlayList.TEXT_NORMAL))">
          <CCol xs="12" md="12" lg="12">
            <div class="input-wrapper form-input-wrapper">
              <div class="form-group">
                <BaseSelect
                  :options="fontFamilySelect.options"
                  :data="fontFamilySelect.data"
                  @update-change="changeFontFamily"
                  ref="fontFamilySelect">
                </BaseSelect>
              </div>
            </div>
          </CCol>
          <CCol xs="12" md="12" lg="12">
            <div class="input-wrapper form-input-wrapper">
              <div class="form-group">
                <BaseSelect
                  :options="fontStyleSelect.options"
                  :data="fontStyleSelect.data"
                  @update-change="changeFontStyle"
                  ref="fontStyleSelect">
                </BaseSelect>
              </div>
            </div>
          </CCol>
          <CCol xs="12" md="12"
                :lg="(item.extractData.isRun == true || type == typeLayer.RSS || type == typeLayer.AREA_TEXT || (item.extractData.typeLayer == typeLayer.PLAY_LIST && item.extractData.type == typePlayList.TEXT_RUN === true)) ? 12 : 6">
            <div class="input-wrapper form-input-wrapper">
              <div class="form-group">
                <BaseSelect
                  :options="textDecorationSelect.options"
                  :data="textDecorationSelect.data"
                  @update-change="changeTextDecoration"
                  ref="textDecorationSelect">
                </BaseSelect>
              </div>
            </div>
          </CCol>
          <CCol xs="12" md="12" lg="12" xl="6">
            <div class="input-wrapper form-input-wrapper">
              <div class="form-group">
                <label>Cỡ chữ (px)</label>
                <input type="number" min="0" class="form-control" v-model="item.attr.fontSize"/>
              </div>
            </div>
          </CCol>
          <CCol xs="12" md="12" lg="12" xl="6"
                v-if="(item.extractData.isRun == true || type == typeLayer.RSS || (item.extractData.typeLayer == typeLayer.PLAY_LIST && item.extractData.type == typePlayList.TEXT_RUN === true))">
            <div class="input-wrapper form-input-wrapper">
              <div class="form-group">
                <label>Tốc độ (s)</label>
                <input type="number" min="0" class="form-control" v-model="item.attr.speed"/>
              </div>
            </div>
          </CCol>
          <CCol xs="12" md="12" lg="12"
                :xl="(item.extractData.isRun == true || type == typeLayer.RSS || (item.extractData.typeLayer == typeLayer.PLAY_LIST && item.extractData.type == typePlayList.TEXT_RUN === true)) ? 12 : 6">
            <div class="input-wrapper form-input-wrapper">
              <div class="form-group">
                <label>Màu nền</label>
                <div class="group-color-picker">
                  <input type="text" class="form-control" disabled v-model="item.attr.background"/>
                  <color-picker v-model="item.attr.background"
                                :position="{right: '0', top: '40px'}"></color-picker>
                </div>
              </div>
            </div>
          </CCol>
          <CCol xs="12" md="12" lg="12" xl="6">
            <div class="input-wrapper form-input-wrapper">
              <div class="form-group">
                <label>Màu chữ</label>
                <div class="group-color-picker">
                  <input type="text" class="form-control" disabled v-model="item.attr.color"/>
                  <color-picker v-model="item.attr.color"
                                :position="{right: '0', top: '40px'}"></color-picker>
                </div>
              </div>
            </div>
          </CCol>
          <CCol xs="12" md="12" lg="12" xl="6">
            <div class="input-wrapper form-input-wrapper">
              <div class="form-group">
                <label>K/cách chữ</label>
                <input type="number" min="0" class="form-control" v-model="item.attr.letterSpacing"/>
              </div>
            </div>
          </CCol>

          <template
            v-if="item.extractData.isRun == false || (item.extractData.typeLayer == typeLayer.PLAY_LIST && item.extractData.type == typePlayList.TEXT_NORMAL)">
            <CCol xs="12" md="12" lg="12" xl="6">
              <div class="input-wrapper form-input-wrapper">
                <div class="form-group">
                  <label>K/cách dòng</label>
                  <input type="number" min="0" class="form-control" v-model="item.attr.lineHeight"/>
                </div>
              </div>
            </CCol>
            <CCol xs="12" md="12" lg="12" xl="12">
              <div class="input-wrapper form-input-wrapper">
                <div class="form-group">
                  <label>Căn chỉnh chữ</label>
                  <div class="group-text-align">
                    <template v-for="item in itemsTextCenter">
                      <span :class="{active : item.active === true }">
                        <i @click="changeTextAlign(item)" :class="item.icon" class="mr-3 fa"
                           v-c-tooltip.hover="item.title"></i>
                      </span>
                    </template>
                  </div>
                </div>
              </div>
            </CCol>
          </template>

        </template>
        <template v-else-if="type == typeLayer.IMAGE || type == typeLayer.VIDEO || type == typeLayer.YOUTUBE || type == typeLayer.RSS || type == typeLayer.DOCUMENT
         || type == typeLayer.AREA_LEFT || type == typeLayer.AREA_RIGHT || type == typeLayer.FULL_SCREEN
        || (item.extractData.typeLayer == typeLayer.PLAY_LIST && (item.extractData.type == typePlayList.IMAGE || item.extractData.type == typePlayList.VIDEO || item.extractData.type == typePlayList.DOCUMENT))">
          <CCol xs="12" md="12" lg="12" xl="12">
            <div class="input-wrapper form-input-wrapper">
              <div class="form-group">
                <label>Lock Accept Ratio</label>
                <div>
                  <CInputCheckbox custom :checked="item.acceptRatio" class="ml-2"
                                  @update:checked="changeAcceptRatio($event)"
                                  addInputClasses="override-custom"></CInputCheckbox>
                </div>
              </div>
            </div>
          </CCol>
          <CCol xs="12" md="12" lg="12" xl="12"
                v-if="type === typeLayer.VIDEO || (item.extractData.typeLayer === typeLayer.PLAY_LIST && item.extractData.type === typePlayList.VIDEO)
                || type === typeLayer.AREA_RIGHT || type === typeLayer.AREA_LEFT || type === typeLayer.FULL_SCREEN">
            <div class="input-wrapper form-input-wrapper">
              <div class="form-group">
                <label>Tắt âm</label>
                <div>
                  <CInputCheckbox custom :checked="item.attr.isMuted" class="ml-2"
                                  @update:checked="changeMuted($event)"
                                  addInputClasses="override-custom"></CInputCheckbox>
                </div>
              </div>
            </div>
          </CCol>
        </template>

        <CCol xs="12" md="12" lg="12" xl="6">
          <div class="input-wrapper form-input-wrapper">
            <div class="form-group">
              <label>Rộng</label>
              <input type="number" min="0" class="form-control" v-model="getWidthTransform"/>
            </div>
          </div>
        </CCol>
        <CCol xs="12" md="12" lg="12" xl="6">
          <div class="input-wrapper form-input-wrapper">
            <div class="form-group">
              <label>Cao</label>
              <input type="number" min="0" class="form-control" v-model="getHeightTransform"/>
            </div>
          </div>
        </CCol>
        <CCol xs="12" md="12" lg="12" xl="6">
          <div class="input-wrapper form-input-wrapper">
            <div class="form-group">
              <label>Đỉnh</label>
              <input type="number" min="0" class="form-control" v-model="getTopTransform"/>
            </div>
          </div>
        </CCol>
        <CCol xs="12" md="12" lg="12" xl="6">
          <div class="input-wrapper form-input-wrapper">
            <div class="form-group">
              <label>Trái</label>
              <input type="number" min="0" class="form-control" v-model="getLeftTransform"/>
            </div>
          </div>
        </CCol>
      </CRow>
    </div>
  </div>
</template>
<script>

import BaseSelect from "@/views/base/BaseSelect2";
import {FontGoogle, TypeChooseLayer, TypePlayList} from "@/constant";

export default {
  name: 'SlideShowFormEditor',
  components: {BaseSelect},
  props: {
    type: Number,
    item: Object
  },
  data: function () {
    let that = this;
    return {
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      loading: {value: false},
      typeLayer: TypeChooseLayer,
      typePlayList: TypePlayList,
      fontFamilySelect: {
        options: {
          filter: false,
          label: "Loại chữ",
          customOptions: true,
          keyField: 'value',
          valueField: 'name',
        },
        data: {
          items: FontGoogle,
          model: that.item.attr.font,
        },
      },
      fontStyleSelect: {
        options: {
          filter: false,
          label: "Kiểu chữ",
        },
        data: {
          items: [
            {key: "normal", value: "Chữ thường"},
            {key: "italic", value: "Chữ nghiêng"},
          ],
          model: that.item.attr.fontStyle,
        },
      },
      textDecorationSelect: {
        options: {
          filter: false,
          label: "Dáng chữ",
        },
        data: {
          items: [
            {key: "none", value: "Bình thường"},
            {key: "line-through", value: "Gạch ngang"},
            {key: "overline", value: "Gạch trên"},
            {key: "underline", value: "Gạch dưới"},
          ],
          model: that.item.attr.textDecoration,
        },
      },
      itemsTextCenter: [
        {id: 1, value: 'left', title: 'Trái', icon: 'fa-align-left', active: false},
        {id: 2, value: 'center', title: 'Giữa', icon: 'fa-align-center', active: false},
        {id: 3, value: 'right', title: 'Phải', icon: 'fa-align-right', active: false},
        {id: 4, value: 'justify', title: 'Căn 2 lề', icon: 'fa-align-justify', active: false}
      ]
    }
  },
  computed: {
    getWidthTransform: {
      get: function () {
        return this.item.transform.width.toFixed(0);
      },
      set: function (newValue) {
        var transform = Object.assign({}, this.item.transform);
        transform.width = Number(newValue);
        this.item.transform = transform;
      }
    },
    getHeightTransform: {
      get: function () {
        return this.item.transform.height.toFixed(0);
      },
      set: function (newValue) {
        var transform = Object.assign({}, this.item.transform);
        transform.height = Number(newValue);
        this.item.transform = transform;
      }
    },
    getTopTransform: {
      get: function () {
        return this.item.transform.y.toFixed(0);
      },
      set: function (newValue) {
        var transform = Object.assign({}, this.item.transform);
        transform.y = Number(newValue);
        this.item.transform = transform;
      },
    },
    getLeftTransform: {
      get: function () {
        return this.item.transform.x.toFixed(0);
      },
      set: function (newValue) {
        var transform = Object.assign({}, this.item.transform);
        transform.x = Number(newValue);
        this.item.transform = transform;
      }
    },
  },
  created() {
  },
  mounted() {
    if (this.type === this.typeLayer.TEXT || this.type === this.typeLayer.PLAY_LIST) {
      this.itemsTextCenter.map(each => {
        if (each.value === this.item.attr.textAlign) {
          each.active = true;
        }
      });
    }
  },
  methods: {
    changeFontFamily(value) {
      this.item.attr.font = value;
    },
    changeFontStyle(value) {
      this.item.attr.fontStyle = value;
    },
    changeTextDecoration(value) {
      this.item.attr.textDecoration = value;
    },
    changeTextAlign(item) {
      this.itemsTextCenter.map(each => {
        if (each.id === item.id) {
          each.active = true;
        } else {
          each.active = false;
        }
      })
      this.item.attr.textAlign = item.value;
    },
    changeAcceptRatio(value) {
      this.item.acceptRatio = value;
    },
    changeParent(value) {
      this.item.parent = value;
    },
    changeMuted(value) {
      this.item.attr.isMuted = value;
    }
  },
  watch: {
    item(value) {
      if (value && value.attr) {
        this.fontFamilySelect.data.model = value.attr.font;
        this.fontStyleSelect.data.model = value.attr.fontStyle;
        this.textDecorationSelect.data.model = value.attr.textDecoration;
        this.itemsTextCenter.map(each => {
          if (each.value === value.attr.textAlign) {
            each.active = true;
          } else {
            each.active = false;
          }
        });
      }
    }
  },
}
</script>
<style scoped>
.group-text-align {
  font-size: 25px;
  color: rgba(169, 168, 168, 0.34);
}

.active {
  color: gray !important;
}

.group-text-align i {
  cursor: pointer;
}
</style>
<style>
#slide-show-form-editor .group-color-picker {
  position: relative;
}

#slide-show-form-editor .one-colorpicker {
  position: absolute;
  top: 1px;
  right: 1px;
}

#slide-show-form-editor .color-block {
  width: 28px;
  height: 34px;
}

#slide-show-form-editor .color-block-layer.value {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>
